"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _kubraUx = require("kubra-ux");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactRedux = require("react-redux");

var _menuActions = require("../actions/menuActions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MenuHeader = function MenuHeader() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var currentMenu = (0, _reactRedux.useSelector)(function (state) {
    return state.menuReducer.currentMenu;
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: 'MenuHeader'
  }, /*#__PURE__*/_react.default.createElement(_kubraUx.TabNav, null, /*#__PURE__*/_react.default.createElement(_kubraUx.TabNavItem, {
    selected: currentMenu === 'TOOLS',
    onClick: function onClick() {
      if (currentMenu === 'TOOLS') dispatch({
        type: _menuActions.CLOSE_MENU
      });else dispatch({
        type: _menuActions.OPEN_MENU,
        nextMenu: 'TOOLS'
      });
    },
    icon: currentMenu === 'TOOLS' ? /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fal', 'times']
    }) : /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'th']
    })
  }, currentMenu === 'TOOLS' ? 'CLOSE' : 'TOOLS'), /*#__PURE__*/_react.default.createElement(_kubraUx.TabNavItem, {
    selected: currentMenu === 'SEARCH',
    onClick: function onClick() {
      if (currentMenu === 'SEARCH') dispatch({
        type: _menuActions.CLOSE_MENU
      });else dispatch({
        type: _menuActions.OPEN_MENU,
        nextMenu: 'SEARCH'
      });
    },
    icon: currentMenu === 'SEARCH' ? /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fal', 'times']
    }) : /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'search']
    })
  }, currentMenu === 'SEARCH' ? 'CLOSE' : 'SEARCH')));
};

var _default = MenuHeader;
exports.default = _default;